import { getFileExtenction } from "./files";
import { T, TF } from "react-translator-component";

const MAX_IMAGE_SIZE_MB = 5;
const imageAllowedExtensions = [".png", ".jpeg", ".jpg", ".webp", ".heic"];

export const imageAcceptedExtension = imageAllowedExtensions.join(",");

export const validateImage = (file: any): string => {
  if (file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
    return TF(T("error_file_size"), MAX_IMAGE_SIZE_MB, T("post_image"));
  }

  if (
    !imageAllowedExtensions.map((ext: string) => ext.replace(/^\./, "")).includes(getFileExtenction(file))
  ) {
    return `${imageAllowedExtensions.join(", ")} ${T("error_image_extension")}`;
  }

  return ""
}
